import type { Component } from 'vue'

import {
  ArrowDown,
  ArrowUp,
  Ban,
  CircleCheck,
  CircleX,
  ClockAlert,
  Hourglass,
  LoaderCircle,
  TriangleAlert,
} from '@lucide/vue'

import IconCustomers from '#app/assets/icons/buying-entities.svg?component'
import IconCrons from '#app/assets/icons/calendar.svg?component'
import IconChats from '#app/assets/icons/chat.svg?component'
import IconEnrichmentAi from '#app/assets/icons/cpu.svg?component'
import IconDeadLetters from '#app/assets/icons/exclamation-circle-outline.svg?component'
import IconFiles from '#app/assets/icons/file-cloud.svg?component'
import IconInvoices from '#app/assets/icons/file.svg?component'
import IconDeliveryBundle from '#app/assets/icons/folder-closed.svg?component'
import IconJobRuns from '#app/assets/icons/history.svg?component'
import IconFileUploads from '#app/assets/icons/import.svg?component'
import IconSkills from '#app/assets/icons/light-bulb.svg?component'
import IconApiKeys from '#app/assets/icons/lock.svg?component'
import IconProjectDimensions from '#app/assets/icons/nav-projects.svg?component'
import IconSupplierDimensions from '#app/assets/icons/nav-suppliers.svg?component'
import IconJobs from '#app/assets/icons/squares-2-stack-outline.svg?component'

export const ICONS = {
  jobs: IconJobs,
  deadLetters: IconDeadLetters,
  jobRuns: IconJobRuns,
  crons: IconCrons,
  enrichmentAi: IconEnrichmentAi,
  fileUploads: IconFileUploads,
  skills: IconSkills,
  chats: IconChats,
  customers: IconCustomers,
  invoices: IconInvoices,
  apiKeys: IconApiKeys,
  deliveryBundle: IconDeliveryBundle,
  files: IconFiles,
  supplierDimensions: IconSupplierDimensions,
  projectDimensions: IconProjectDimensions,
} satisfies Record<string, Component>

/**
 * One glyph per kind of progress, for a status shown as an icon rather than a word. Lucide's,
 * because the domain set has no line-art for these.
 */
export const STATUS_ICONS = {
  waiting: Hourglass,
  running: LoaderCircle,
  done: CircleCheck,
  attention: TriangleAlert,
  failed: CircleX,
  timedOut: ClockAlert,
  cancelled: Ban,
} satisfies Record<string, Component>

/** Moving an item one place up or down an ordered list. */
export const MOVE_ICONS = {
  up: ArrowUp,
  down: ArrowDown,
} satisfies Record<string, Component>
